module.exports = __webpack_public_path__ + "images/frontpage_download@2x.png?60afe63e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_download@2x.png
// module id = 637
// module chunks = 7